import { FieldList } from '@hotjar/hotsauce';
import type { Position } from '@hotjar/feedback/domain/IncomingFeedback/Position';

import { useTranslationWithPrefix } from '@hotjar/translations';
import { IconOption } from '../../../../../common/AdvancedSelectA11y/IconOption';
import { AdvancedSelect } from '../../../../../common/AdvancedSelectA11y/AdvancedSelect';

export interface PositionSelectorProps {
  position: Position;
  onChange: (position: Position) => void;
}

/* eslint-enable camelcase */
const postions: Record<string, Position> = {
  middle_right: 'middle_right',
  middle_left: 'middle_left',
  bottom_right: 'bottom_right',
  bottom_left: 'bottom_left',
};

export const PositionSelector = ({ position, onChange }: PositionSelectorProps): JSX.Element => {
  const { t } = useTranslationWithPrefix('feedback:wizard.position-selector');
  const label = t('position-label');
  return (
    <FieldList title={label} size="m">
      <AdvancedSelect
        id="position-selector"
        ariaLabel={label}
        selectedValue={position}
        onSelect={(selectedValue) => onChange(postions[selectedValue])}
      >
        <IconOption id="middle-left" value="middle_left" icon="position_middle_left">
          {t('middle-left')}
        </IconOption>
        <IconOption id="middle-right" value="middle_right" icon="position_middle_right">
          {t('middle-right')}
        </IconOption>
        <IconOption id="bottom-right" value="bottom_right" icon="position_bottom_right">
          {t('bottom-right')}
        </IconOption>
        <IconOption id="bottom-left" value="bottom_left" icon="position_bottom_left">
          {t('bottom-left')}
        </IconOption>
      </AdvancedSelect>
    </FieldList>
  );
};
